/* eslint-disable no-unsafe-optional-chaining */
import CheckMark from '@/assets/icons/checkmark';

/* eslint-disable @typescript-eslint/indent */
const Stepper = ({
  currentStep,
  handleCurrentStep,
}: {
  currentStep: number;
  handleCurrentStep: (step: number) => void;
}) => {
  const steps = ['About You', 'Preferences', 'Details'];
  return (
    <div className="flex justify-between items-center w-[100%] large:max-w-[650px] large:!justify-end medium:py-4 large:pb-3 large:pt-0 large:px-2">
      {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;

        return (
          <div
            key={step}
            className={`flex items-center gap-2 ${index < steps.length - 1 ? 'flex-1' : ''}`}
            onClick={() => handleCurrentStep(steps.indexOf(step) + 1)}
          >
            <div
              className={`w-[14px] h-[14px] medium:!w-6 medium:!h-6 rounded-full flex items-center justify-center font-normal font-nunito text-[12px]
              ${
                isCompleted
                  ? 'bg-green-500 text-white cursor-pointer'
                  : isActive
                  ? 'bg-orange-500 text-white'
                  : 'bg-gray-300 text-white'
              }`}
            >
              {isCompleted ? (
                <CheckMark className="w-3 h-3 medium:!w-4 medium:!h-4" />
              ) : (
                <span className="flex justify-center items-center text-[9px] medium:text-sm">
                  {index + 1}
                </span>
              )}
            </div>
            <span
              className={`font-bold text-[12px] medium:!text-[16px] font-nunito ${
                currentStep === index
                  ? 'text-[#E97862] font-thin medium:font-bold'
                  : 'text-gray-500 font-light'
              }`}
            >
              {step}
            </span>
            {index < steps.length - 1 && (
              <div className="flex-1 h-[1px] bg-gray-300 mr-2 large:ml-4 large:!mr-6" />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
